import { LinkedPersonInfo } from "../../../generated/data-contracts";

export function LinkedPersonsListItem(props: LinkedPersonInfo) {
  const { name, additionalInfo } = props;

  return <li>{additionalInfo ? `${name} (${additionalInfo})` : name}</li>;
}
